import { Component, inject, Input, OnInit } from "@angular/core";
import { ComponentBase } from "../../../models/ComponentBase";
import { GetStorageItemResponse } from "../../../WebApiClient";
import { UntypedFormControl } from "@angular/forms";
import { ChartJsData, ChartJsDatasetFill } from "../../../models/ChartJsDataset";
import { StorageService } from "../../../services/storage.service";

@Component({
    selector: "app-storage-quantity-accumulate",
    templateUrl: "./storage-item-quantityaccumulate.component.html",
    styleUrls: [
        "./storage-item-quantityaccumulate.component.scss" /*, '../../style/info-group.scss'*/,
    ],
    standalone: false,
})
export class StorageQuantityAccumulateComponent
    extends ComponentBase
    implements OnInit
{
    @Input() storageItem: GetStorageItemResponse | undefined;

    public movementYearSelectorControl: UntypedFormControl =
        new UntypedFormControl();
    public movementYearSelected: number | undefined = undefined;

    public chartJsData: ChartJsData = {
        labels: [],
        datasets: [],
    };

    public xLabel : string | undefined  = "Dates per year";
    public yLabel : string | undefined  = "";

    movementChartShow: boolean = false;
    initCall: boolean = false;

    constructor(
            private storageService: StorageService
        ) {
            super();

            let movementYearSelectorSubscription =
                this.movementYearSelectorControl.valueChanges.subscribe((year) => {
                    this.movementYearSelected = year;
                    this.bindAccumulatedQuantityChart();
                });

            this.subscriptions.push(movementYearSelectorSubscription);
        }

    ngOnInit(): void {
        if (this.storageItem && this.storageItem.movementYears) {
            this.movementYearSelected = this.storageItem.movementYears[0];
            this.movementYearSelectorControl.setValue(
                this.movementYearSelected
            );
            this.yLabel = this.storageItem.baseUnitOfMeasure;
            this.bindAccumulatedQuantityChart();
        }
    }

    bindAccumulatedQuantityChart(): void {
        if (
            !this.storageItem ||
            !this.storageItem.id ||
            !this.movementYearSelected
        ) {
            return;
        }

        if (this.initCall) {
            this.initCall = false;
            return;
        }

        this.storageService
            .getStorageAccumulatedQuantityObservable(
                this.storageItem.id,
                this.movementYearSelected
            )
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.chartJsData = {

                    labels: data.map((d) => d.dayMonth ?? ""),
                    datasets: [
                        {
                            label: "Quantity",
                            data: data.map((d) => d.total ?? 0),
                            backgroundColor: "rgba(48, 140, 207, 1)",
                            borderWidth: 4,
                            borderColor: "rgba(48, 140, 207, 1)",
                            pointRadius: 0.5,
                            tension: 0,
                            fill:  new ChartJsDatasetFill()
                        }
                    ],
                };
                this.movementChartShow = true;
            });
    }
}
